module.exports = __webpack_public_path__ + "static/15-68c70490bd9d622b9ddbb20caf13904f.jpeg";